<template>
  <Base :detail="detail" v-if="defaultPrize && defaultPrize.length > 0" :show-loading="showLoading">
    <div
      class="luckdraw-warp"
      :style="'width:' + 600 * baseSize + 'px;'"
      :class="running ? 'running' : ''"
    >
      <img
        :src="require('@/assets/img/award/box.png')"
        style="max-width:1000px;width:100%"
      />
      <div class="luckdraw-grid">
        <div
          class="luckdraw-grid-item d"
          v-for="index in 4"
          :key="index"
          :class="activeIndex === indexMap[index - 1] ? 'active' : ''"
        >
          <img :src="prizes[index - 1].image" />
        </div>
        <img
          :src="require('@/assets/img/award/grid_start.png')"
          class="luckdraw-grid-item"
          @click="startCallBack()"
        />
        <!-- <img
            :src="require('@/assets/img/award/grid_start.png')"
            class="luckdraw-grid-item"
            v-else
          /> -->
        <div
          class="luckdraw-grid-item d"
          v-for="index in 4"
          :key="index + 4"
          :class="activeIndex === indexMap[index + 3] ? 'active' : ''"
        >
          <img :src="prizes[index + 3].image" />
        </div>
      </div>
      <div class="luckdraw-light-top">
        <template v-for="item in 5">
          <div class="light-item" :key="'top' + item" v-if="item % 2 === 1">
            <img
              :src="require('@/assets/img/award/light.png')"
              v-if="!showOdd"
            />
            <img :src="require('@/assets/img/award/light2.png')" v-else />
          </div>
          <div class="light-item" :key="'top' + item" v-else>
            <img
              :src="require('@/assets/img/award/light.png')"
              v-if="showOdd"
            />
            <img :src="require('@/assets/img/award/light2.png')" v-else />
          </div>
        </template>
      </div>
      <div class="luckdraw-light-right">
        <template v-for="item in 5">
          <div class="light-item" :key="'right' + item" v-if="item % 2 === 1">
            <img
              :src="require('@/assets/img/award/light.png')"
              v-if="!showOdd"
            />
            <img :src="require('@/assets/img/award/light2.png')" v-else />
          </div>
          <div class="light-item" :key="'right' + item" v-else>
            <img
              :src="require('@/assets/img/award/light.png')"
              v-if="showOdd"
            />
            <img :src="require('@/assets/img/award/light2.png')" v-else />
          </div>
        </template>
      </div>
      <div class="luckdraw-light-bottom">
        <template v-for="item in 5">
          <div class="light-item" :key="'bottom' + item" v-if="item % 2 === 1">
            <img
              :src="require('@/assets/img/award/light.png')"
              v-if="!showOdd"
            />
            <img :src="require('@/assets/img/award/light2.png')" v-else />
          </div>
          <div class="light-item" :key="'bottom' + item" v-else>
            <img
              :src="require('@/assets/img/award/light.png')"
              v-if="showOdd"
            />
            <img :src="require('@/assets/img/award/light2.png')" v-else />
          </div>
        </template>
      </div>
      <div class="luckdraw-light-left">
        <template v-for="item in 5">
          <div class="light-item" :key="'left' + item" v-if="item % 2 === 1">
            <img
              :src="require('@/assets/img/award/light.png')"
              v-if="!showOdd"
            />
            <img :src="require('@/assets/img/award/light2.png')" v-else />
          </div>
          <div class="light-item" :key="'left' + item" v-else>
            <img
              :src="require('@/assets/img/award/light.png')"
              v-if="showOdd"
            />
            <img :src="require('@/assets/img/award/light2.png')" v-else />
          </div>
        </template>
      </div>
    </div>
    <div
      class="active-num"
      :style="
        'margin-top:' +
          56 * baseSize +
          'px;margin-bottom:' +
          56 * baseSize +
          'px;width:' +
          692 * baseSize +
          'px'
      "
    >
      <div
        class="active-num-text"
        :style="
          'bottom:' + 60 * baseSize + 'px; font-size:' + 24 * baseSize + 'px'
        "
      >
        <!-- 已有<span>{{ detail.join_num }}</span
        >人参与<br />
        您今天还有<span class="underline yellow">{{ chance }}</span
        >次抽奖机会 -->
        You've got <span class="underline yellow">{{ chance }}</span
        > times<br>left to draw for today.
      </div>
    </div>
    <PrizeDetail :detail="detail" :myAwards="myAwards" />
  </Base>
</template>

<script>
import { LuckDrawMixin } from "@/mixins/Luckdraw";
export default {
  mixins: [LuckDrawMixin],
  data() {
    return {
      prizes: [],
      defaultPrize: [],
      running: false,
      activeIndex: -1,
      endIndex: -1,
      resultIndex: -1,
      indexMap: [0, 1, 2, 7, 3, 6, 5, 4],
      round: 0,
      tid: null,
      showOdd: false
    };
  },
  mounted(){
    setInterval(() => {
      this.showOdd=!this.showOdd;
    }, 500);
  },
  methods: {
    init() {
      this.running = false;
      this.round = 0;
      this.activeIndex = -1;
      this.endIndex = -1;
      this.resultIndex = -1;
    },
    handleData(data) {
      let temp = { ...data };
      if (!temp.background_img)
        temp.background_img = require("@/assets/img/award/beij.jpg");
      if (!temp.brief_img)
        temp.brief_img = require("@/assets/img/award/title.png");
      this.detail = { ...temp };
      this.myAwards = [...this.detail.my_awards];
      this.chance = this.detail.remaining_num || 0;
      this.defaultPrize = [...data.prizes];
      this.prizes = [...this.resort(this.defaultPrize)];
    },
    resort(list) {
      // 4-ABCDBC 5-ABDECD 6-ABDFCE 7-ABCFGDEF 8-ABCFHDEG
      if (list.length === 4) {
        const [A, B, C, D] = list;
        return [D, C, B, A, A, B, C, D];
      } else if (list.length === 5) {
        const [A, B, C, D, E] = list;
        return [A, B, C, D, E, B, C, D];
      } else if (list.length === 6) {
        const [A, B, C, D, E, F] = list;
        return [A, B, D, E, F, C, D, E];
      } else if (list.length === 7) {
        const [A, B, C, D, E, F, G] = list;
        return [A, B, C, F, G, D, E, F];
      } else if (list.length === 8) {
        const [A, B, C, D, E, F, G, H] = list;
        return [A, B, C, F, H, D, E, G];
      }
    },
    startCallBack() {
      if(!this.checkLogin()) return ;
      if (this.running) return;
      const endTime = this.detail.end_time
        ? new Date(this.detail.end_time.replace(/-/g, "/")).getTime()
        : "";
      const nowTime = new Date().getTime();
      if (!endTime || endTime < nowTime) {
        this.showMessage("Game over!");
        return;
      }
      if (this.chance < 1) {
        this.showMessage("No chance today, come back tomorrow.!");
        return;
      }
      this.running = true;
      this.getResult();
    },
    rollItemChange(speed) {
      setTimeout(() => {
        if (speed > 40 && this.round === 0) speed -= 10;
        if (this.activeIndex >= 7) {
          this.activeIndex = 0;
          if (speed === 40) this.round += 1;
        } else this.activeIndex += 1;
        if (this.round >= 10 && speed < 200) speed += 10;
        // if(this.endIndex>-1&&speed<200) speed+=10;
        if (
          this.endIndex > -1 &&
          speed >= 200 &&
          this.endIndex === this.activeIndex
        ) {
          setTimeout(() => {
            this.endCallback();
          }, 500);
        } else this.rollItemChange(speed);
      }, speed);
    },
    handleResult(data) {
      this.rollItemChange(200);
      this.chance -= 1;
      this.result = { ...data.award };
      this.resultIndex = this.getIndex(this.result.id);
      this.endIndex = this.indexMap[this.resultIndex];
    },
    getIndex(id) {
      let temp = [];
      this.prizes.forEach((item, index) => {
        if (item.id === id) temp.push(index);
      });
      const len = temp.length;
      if (len < 1 && id !== 0) return this.getIndex(0);
      else if (len === 1) return temp[0];
      else if (len > 1) return temp[Math.floor(len * Math.random())];
    },
    endCallback() {
      const { id, title, level, image } = this.result;
      if(id) this.myAwards.unshift({ id, title, level, image });
      if (id === 0) {
        this.showResult({ type: 1 });
      } else {
        this.showResult({ type: 3, title, level });
      }
    }
  }
};
</script>

<style scoped lang="scss">
img {
  display: block;
  max-width: 100%;
}

.underline {
  text-decoration: underline;
}
.d-warp {
  width: 100%;
  max-width: 640px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
  .main {
    width: 100%;
    min-height: 100vh;
    .luckdraw-warp,
    .title-warp {
      margin: 0 auto;
    }
    .luckdraw-warp {
      position: relative;
      z-index: 2;
    }
    .luckdraw-grid {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      padding: 2.5rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;
      z-index: 1;
      .luckdraw-grid-item {
        width: 7.9rem;
        height: 7.9rem;
        box-sizing: border-box;
        position: relative;
        &.d {
          border: 1px solid #e64133;
          background: #fff;
          border-radius: 1.4rem;
        }
      }
    }
    .running {
      &::after {
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: none;
        z-index: 2;
      }
      .luckdraw-grid-item {
        &.d {
          &::after {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            content: "";
            background: rgba(0, 0, 0, 0.2);
            border-radius: 1.4rem;
            z-index: 2;
          }
          &.active {
            &::after {
              background: none;
            }
          }
        }
      }
    }
    .active-num {
      position: relative;
      z-index: 1;
      margin-left: auto;
      margin-right: auto;
      img {
        padding-left: 1%;
      }
    }
    .active-num-text {
      font-size: 12px;
      text-align: center;
      color: #fff;
      line-height: 1.4;
      span {
        display: inline-block;
        margin: 0 2px;
      }
    }
  }
}
.luckdraw-light-top,
.luckdraw-light-bottom,
.luckdraw-light-left,
.luckdraw-light-right {
  position: absolute;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.luckdraw-light-top,
.luckdraw-light-bottom {
  left: 0;
  padding: 0 3.6rem;
  height: 1.8rem;
  width: 100%;
}
.luckdraw-light-bottom {
  bottom: 0;
}
.luckdraw-light-top {
  top: 0;
}
.luckdraw-light-left,
.luckdraw-light-right {
  top: 0;
  padding: 3.6rem 0;
  height: 100%;
  width: 1.8rem;
  flex-direction: column;
}
.luckdraw-light-right {
  right: 0;
}
.luckdraw-light-left {
  left: 0;
}
.light-item {
  width: 1.8rem;
  height: 1.8rem;
  img {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/LuckyGrid.vue